export default __webpack_public_path__ + "static/media/comingsoon2.1d54cc5c.jpg";